// font families
// font families
export const FONT_FAMILIES = [
  {
    id: 'system-default',
    name: 'System Default',
    value: 'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
  },
  {
    id: 'roboto',
    name: 'Roboto',
    value: '"Roboto", sans-serif'
  },
  {
    id: 'noto-sans',
    name: 'Noto Sans',
    value: '"Noto Sans", "Noto Sans CJK SC", "Noto Sans CJK TC", "Noto Sans CJK JP", "Noto Sans CJK KR", sans-serif'
  },
  {
    id: 'open-sans',
    name: 'Open Sans',
    value: '"Open Sans", sans-serif'
  },
  {
    id: 'lato',
    name: 'Lato',
    value: '"Lato", sans-serif'
  },
  {
    id: 'ubuntu',
    name: 'Ubuntu',
    value: '"Ubuntu", sans-serif'
  },
  {
    id: 'pt-sans',
    name: 'PT Sans',
    value: '"PT Sans", sans-serif'
  },
  {
    id: 'montserrat',
    name: 'Montserrat',
    value: '"Montserrat", sans-serif'
  },
  {
    id: 'ibm-plex-sans',
    name: 'IBM Plex Sans',
    value: '"IBM Plex Sans", "IBM Plex Sans KR", "IBM Plex Sans JP", "IBM Plex Sans CN", sans-serif'
  },
  {
    id: 'source-han-sans',
    name: 'Source Han Sans',
    value: '"Source Han Sans", "Source Han Sans CN", "Source Han Sans JP", "Source Han Sans KR", "Source Han Sans TW", sans-serif'
  },
  {
    id: 'droid-sans',
    name: 'Droid Sans',
    value: '"Droid Sans", "Droid Sans Fallback", sans-serif'
  },
  {
    id: 'alegreya-sans',
    name: 'Alegreya Sans',
    value: '"Alegreya Sans", sans-serif'
  },
  // Adding new font options from already loaded fonts
  {
    id: 'inter',
    name: 'Inter',
    value: '"Inter", sans-serif'
  },
  {
    id: 'source-sans',
    name: 'Source Sans Pro',
    value: '"Source Sans Pro", sans-serif'
  },
  {
    id: 'poppins',
    name: 'Poppins',
    value: '"Poppins", sans-serif'
  },
  {
    id: 'quicksand',
    name: 'Quicksand',
    value: '"Quicksand", sans-serif'
  },
  {
    id: 'fira-sans',
    name: 'Fira Sans',
    value: '"Fira Sans", sans-serif'
  },
  {
    id: 'times-new-roman',
    name: 'Times New Roman',
    value: '"Times New Roman", Times, serif'
  }
];

// drag-and-drop support
export const ItemTypes = {
  CHAT_SESSION: 'chatSession',
  PROJECT: 'project'
};

// project support
export const PROJECT_COLORS = [
  { id: 'purple', value: '#9c27b0' },
  { id: 'blue', value: '#2196f3' },
  { id: 'green', value: '#4caf50' },
  { id: 'yellow', value: '#ffeb3b' },
  { id: 'orange', value: '#ff9800' },
  { id: 'red', value: '#f44336' },
];

// Font colors suitable for message display
export const FONT_COLORS_DARK = [
  { id: 'default', value: 'inherit', name: 'Default' },
  { id: 'black', value: '#000000', name: 'Black' },
  { id: 'gray', value: '#D3D3D3', name: 'Gray' },
  { id: 'blue', value: '#ADD8E6', name: 'Blue' },
  { id: 'green', value: '#B2D8B2', name: 'Green' },
  { id: 'red', value: '#FFB6C1', name: 'Red' },
  { id: 'purple', value: '#D8BFD8', name: 'Purple' },
];

export const FONT_COLORS_LIGHT = [
  { id: 'default', value: 'inherit', name: 'Default' },
  { id: 'black', value: '#000000', name: 'Black' },
  { id: 'gray', value: '#333333', name: 'Gray' },
  { id: 'blue', value: '#000066', name: 'Blue' },
  { id: 'green', value: '#006400', name: 'Green' },
  { id: 'red', value: '#8B0000', name: 'Red' },
  { id: 'purple', value: '#4B0082', name: 'Purple' },
];

// Guru Engine configurations
export const GURU_DEFAULT_PROMPT = `Here is the current user prompt enclosed in << >> brackets:
<<{userMessage}>>
  
Below are several potential replies, the start of each reply is enclosed in << >> brackets:
{engineResponses}
  
Consider these possible replies, evaluate their accuracy, and incorporate the most relevant information from them to generate the final response.
Use your own knowledge and reasoning to improve upon these replies.
If any of the replies contain misinformation or lack important context, feel free to correct them in your final response.
The final response should retain the language used in the conversation, but you should aim to create the best response possible with your knowledge as the primary guide.
Please provide just the final response without any comments regarding this prompt`;

export const GURU_DEFAULT_SETTINGS = {
  leadingEngine: 'gemini',
  enginesUsed: ['chatgpt', 'claude', 'deepseek'],
  guruPrompt: GURU_DEFAULT_PROMPT
};

// default settings
export const DEFAULT_SETTINGS = {
  translit: false,
  voiceControl: false,
  selectedEngine: 'gemini',
  fontSize: 14,
  fontFamily: 'system-default',
  themeMode: 'light',
  language: 'en',
  ctrlEnterToSend: false,
  guruSettings: GURU_DEFAULT_SETTINGS,
  userLocation: null,
  wallpaper: null,
  customWallpaper: null,
  wallpaperScaling: 'cover', // Default scaling is 'cover'
  showChainOfThought: false, // Chain of Thought display setting
  alwaysUseThinking: false // Always use thinking mode when supported by model
};

// Services definitions
export const SERVICES = [
  { key: '', text: 'service.none' },
  { key: 'adjustText', text: 'service.adjustText' },
  { key: 'optimizePrompt', text: 'service.optimizePrompt' },
  //  { key: 'webSearch', text: 'service.webSearch' }
];

// AI Engines
export const ENGINES = [
  { key: 'guru', text: 'engine.guru', icon: '/assets/logos/guru.png' },
  { key: 'chatgpt', text: 'engine.chatgpt', icon: '/assets/logos/openai.png' },
  { key: 'claude', text: 'engine.claude', icon: '/assets/logos/claude.png' },
  { key: 'gemini', text: 'engine.gemini', icon: '/assets/logos/gemini.png' },
  { key: 'deepseek', text: 'engine.deepseek', icon: '/assets/logos/deepseek.png' },
  { key: 'grok', text: 'engine.grok', icon: '/assets/logos/grok.png' },
];

// Theme modes
export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark'
};

// Language options
export const LANGUAGES = [
  { code: 'en', countryCode: 'GB' },
  { code: 'ru', countryCode: 'RU' },
  { code: 'de', countryCode: 'DE' },
  { code: 'es', countryCode: 'ES' },
];

// Font size configuration
export const FONT_SIZE = {
  MIN: 10,
  MAX: 20,
  STEP: 2,
  DEFAULT: 14
};

// File upload configuration
export const UPLOAD_CONFIG = {
  ACCEPTED_TYPES: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'text/plain',
    'text/markdown',
    'application/pdf',
  ],
  MAX_SIZE: 32 * 1024 * 1024, // 32MB
  MAX_FILES: 10
};

export const FILE_TYPES = {
  IMAGE: 'image',
  TEXT: 'text',
  PDF: 'pdf'
};

// API endpoints 
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    VERIFY_EMAIL: '/api/auth/verify',
    RESET_PASSWORD: '/api/auth/reset-password',
    GOOGLE_AUTH: '/api/auth/google/url'
  },
  CHAT: {
    SEND_MESSAGE: '/api/chat/chat',
    GET_HISTORY: '/api/chat/conversation-history',
    RESET: '/api/chat/reset',
    OPTIMIZE: '/api/chat/optimize',
    UPDATE_ENGINE: '/api/chat/engine'
  },
  USER: {
    SETTINGS: '/api/chat/user-settings',
    SESSIONS: '/api/chat/sessions'
  }
};

// Message roles
export const MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant'
};

// Local storage keys
export const STORAGE_KEYS = {
  JWT_TOKEN: 'jwtToken',
  THEME_MODE: 'themeMode',
  LANGUAGE: 'language'
};

// Default values
export const DEFAULTS = {
  CHAT_HEIGHT: window.innerHeight * 0.2,
  HEADER_HEIGHT: 60,
  MIN_CONTROL_HEIGHT: 150
};

// Error messages
export const ERROR_MESSAGES = {
  UNAUTHORIZED: 'error.unauthorized',
  NETWORK_ERROR: 'error.network',
  INVALID_FILE: 'error.invalidFile',
  SESSION_EXPIRED: 'error.sessionExpired'
};

// Success messages
export const SUCCESS_MESSAGES = {
  COPIED: 'notification.copied',
  MESSAGE_SENT: 'message.sent',
  SETTINGS_SAVED: 'settings.saved'
};

export const ENGINE_TEMPERATURE_DEFAULTS = {
  chatgpt: 1.0,
  claude: 1.0,
  gemini: 1.0,
  deepseek: 1.0,
  grok: 1.0
};

export const ENGINE_TEMPERATURE_RANGES = {
  chatgpt: { min: 0, max: 2 },
  claude: { min: 0, max: 1 },
  gemini: { min: 0, max: 2 },
  deepseek: { min: 0, max: 2 },
  grok: { min: 0, max: 2 }
};

// AI Models metadata
// src/constants/appConstants.js - Update MODEL_METADATA

export const MODEL_METADATA = {
  'gpt-4.1': {
    description: 'GPT-4.1 is a flagship model for complex tasks. It is well suited for problem solving across domains',
    speed: 6,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 7,
    contextWindow: 1047576,
    outputTokens: 32768,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 8,
    reasoning: false,
    webSearch: true
  },
  'gpt-4.1-mini': {
    description: 'GPT-4.1 mini provides a balance between intelligence, speed, and cost that makes it an attractive model for many use cases',
    speed: 8,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 3,
    contextWindow: 1047576,
    outputTokens: 32768,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 6,
    reasoning: false,
    webSearch: true
  },
  'gpt-4.1-nano': {
    description: 'GPT-4.1 nano is the fastest, most cost-effective GPT-4.1 model',
    speed: 10,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 1,
    contextWindow: 1047576,
    outputTokens: 32768,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 4,
    reasoning: false,
    webSearch: false
  },
  'gpt-4o': {
    description: 'GPT-4o is a versatile, high-intelligence flagship model. It is the best model for most tasks, and is the most capable model outside of o-series models.',
    speed: 6,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 8,
    contextWindow: 128000,
    outputTokens: 16384,
    knowledgeCutoff: 'Oct 2023',
    intelligence: 7,
    reasoning: false,
    webSearch: true
  },
  'o3': {
    description: 'o3 is a well-rounded and powerful model across domains. It sets a new standard for math, science, coding, and visual reasoning tasks. It also excels at technical writing and instruction-following.',
    speed: 1,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 10,
    contextWindow: 200000,
    outputTokens: 100000,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 10,
    reasoning: true,
    webSearch: false
  },
  'o3-mini': {
    description: 'o3-mini is the newest small reasoning model, providing high intelligence at the same cost and latency targets of o1-mini.',
    speed: 6,
    inputTypes: ['text'],
    pricing: 4,
    contextWindow: 200000,
    outputTokens: 100000,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 7,
    reasoning: true,
    webSearch: false
  },
  'o4-mini': {
    description: 'o4-mini is the latest small o-series model. It\'s optimized for fast, effective reasoning with exceptionally efficient performance in coding and visual tasks.',
    speed: 6,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 4,
    contextWindow: 200000,
    outputTokens: 100000,
    knowledgeCutoff: 'Oct 2023',
    intelligence: 6,
    reasoning: true,
    webSearch: false
  },
  'claude-opus-4-0': {
    description: 'Our most capable and intelligent model yet. Claude Opus 4 sets new standards in complex reasoning and advanced coding',
    speed: 1,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 10,
    contextWindow: 200000,
    outputTokens: 32000,
    knowledgeCutoff: 'Mar 2025',
    intelligence: 10,
    reasoning: true,
    webSearch: false
  },
  'claude-sonnet-4-0': {
    description: 'High-performance model with exceptional reasoning and efficiency',
    speed: 3,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 9,
    contextWindow: 200000,
    outputTokens: 64000,
    knowledgeCutoff: 'Mar 2025',
    intelligence: 10,
    reasoning: true,
    webSearch: false
  },
  'claude-3-7-sonnet-latest': {
    description: 'Most intelligent Claude model. Highest level of intelligence and capability with toggleable extended thinking',
    speed: 3,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 9,
    contextWindow: 200000,
    outputTokens: 64000,
    knowledgeCutoff: 'Nov 2024',
    intelligence: 10,
    reasoning: true,
    webSearch: false
  },
  'claude-3-5-haiku-latest': {
    description: 'Fastest Claude model. Intelligence at blazing speeds',
    speed: 3,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 3,
    contextWindow: 200000,
    outputTokens: 8192,
    knowledgeCutoff: 'Jul 2024',
    intelligence: 5,
    reasoning: false,
    webSearch: false
  },
  'gemini-2.5-pro': {
    description: 'Gemini 2.5 Pro is a state-of-the-art thinking model, capable of reasoning over complex problems in code, math, and STEM, as well as analyzing large datasets, codebases, and documents using long context.',
    speed: 8,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 7,
    contextWindow: 1048576,
    outputTokens: 65536,
    knowledgeCutoff: 'Jan 2025',
    intelligence: 10,
    reasoning: true,
    webSearch: true
  },
  'gemini-2.5-flash': {
    description: 'Best model in terms of price-performance, offering well-rounded capabilities',
    speed: 7,
    inputTypes: ['text', 'image', 'pdf'],
    pricing: 2,
    contextWindow: 1048576,
    outputTokens: 65536,
    knowledgeCutoff: 'Jan 2025',
    intelligence: 7,
    reasoning: true,
    webSearch: true
  },
  'deepseek-chat': {
    description: 'DeepSeek-V3 pioneers an auxiliary-loss-free strategy for load balancing and sets a multi-token prediction training objective for stronger performance',
    speed: 1,
    inputTypes: ['text'],
    pricing: 3,
    contextWindow: 64000,
    outputTokens: 8192,
    knowledgeCutoff: 'Jun 2024',
    intelligence: 6,
    reasoning: false,
    webSearch: false
  },
  'deepseek-reasoner': {
    description: 'Reasoning model developed by DeepSeek. Before delivering the final answer, the model first generates a Chain of Thought (CoT) to enhance the accuracy of its responses.',
    speed: 1,
    inputTypes: ['text'],
    pricing: 5,
    contextWindow: 64000,
    outputTokens: 8192,
    knowledgeCutoff: 'Oct 2023',
    intelligence: 8,
    reasoning: true,
    webSearch: false
  },

  'grok-4-latest': {
    description: 'Our latest and greatest flagship model, offering unparalleled performance in natural language, math and reasoning - the perfect jack of all trades.',
    speed: 4,
    inputTypes: ['text', 'image'],
    pricing: 8,
    contextWindow: 256000,
    outputTokens: 32768,
    knowledgeCutoff: 'Dec 2024',
    intelligence: 10,
    reasoning: true,
    webSearch: true
  }
};
// Available models for each engine
export const AVAILABLE_MODELS = {
  chatgpt: [
    { id: 'gpt-4.1', name: 'GPT-4.1' },
    { id: 'gpt-4.1-mini', name: 'GPT-4.1 mini' },
    { id: 'gpt-4.1-nano', name: 'GPT-4.1 nano' },
    { id: 'gpt-4o', name: 'GPT-4o' },
    { id: 'o3', name: 'o3' },
    { id: 'o3-mini', name: 'o3-mini' },
    { id: 'o4-mini', name: 'o4-mini' }
  ],
  claude: [
    { id: 'claude-opus-4-0', name: 'Claude 4.0 Opus' },
    { id: 'claude-sonnet-4-0', name: 'Claude 4.0 Sonnet' },
    { id: 'claude-3-7-sonnet-latest', name: 'Claude 3.7 Sonnet' },
    { id: 'claude-3-5-haiku-latest', name: 'Claude 3.5 Haiku' }
  ],
  gemini: [
    { id: 'gemini-2.5-pro', name: 'Gemini 2.5 Pro' },
    { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' }
  ],
  deepseek: [
    { id: 'deepseek-chat', name: 'DeepSeek-V3' },
    { id: 'deepseek-reasoner', name: 'DeepSeek-R1' }
  ],
  grok: [
    { id: 'grok-4-latest', name: 'Grok 4' }
  ]
};

// Default models for each engine
export const DEFAULT_ENGINE_MODELS = {
  chatgpt: 'gpt-4.1',
  claude: 'claude-sonnet-4-0',
  gemini: 'gemini-2.5-pro',
  deepseek: 'deepseek-reasoner',
  grok: 'grok-4-latest'
};

// Add this to src/constants/appConstants.js

export const MODEL_DISPLAY_NAMES = {
  'chatgpt': {
    'gpt-4.1': 'ChatGPT-4.1',
    'gpt-4.1-mini': 'ChatGPT-4.1 mini',
    'gpt-4.1-nano': 'ChatGPT-4.1 nano',
    'gpt-4o': 'ChatGPT-4o',
    'o3': 'ChatGPT-o3',
    'o3-mini': 'ChatGPT-o3 mini',
    'o4-mini': 'ChatGPT-o4 mini'
  },
  'claude': {
    'claude-opus-4-0': 'Claude-4.0 opus',
    'claude-sonnet-4-0': 'Claude-4.0 sonnet',
    'claude-3-7-sonnet-latest': 'Claude-3.7 sonnet',
    'claude-3-5-haiku-latest': 'Claude-3.5 haiku'
  },
  'gemini': {
    'gemini-2.5-pro': 'Gemini-2.5 pro',
    'gemini-2.5-flash': 'Gemini-2.5 flash'
  },
  'deepseek': {
    'deepseek-chat': 'DeepSeek-V3',
    'deepseek-reasoner': 'DeepSeek-R1'
  },
  'grok': {
    'grok-4-latest': 'Grok-4'
  }
};

// Function to get the display name for an engine/model combination
export const getModelDisplayName = (engine, model) => {
  if (!engine || !model) return null;

  if (MODEL_DISPLAY_NAMES[engine] && MODEL_DISPLAY_NAMES[engine][model]) {
    return MODEL_DISPLAY_NAMES[engine][model];
  }

  // If no specific display name found, create a generic one
  const engineName = engine.charAt(0).toUpperCase() + engine.slice(1);
  return `${engineName} (${model})`;
};

export const TEXT_LENGTH_THRESHOLD = 1000; // Characters threshold for conversion to attachment
export const MAX_ATTACHMENT_SIZE = 1024 * 1024; // 1MB limit for text attachments